<template>
	<div class="content">
		<div class="header">
			 <el-radio v-model="form.radio" label="1" @change="name()" style="margin-top:10px;margin-bottom: 20px;">组</el-radio>
			 <el-radio v-model="form.radio" label="2" @change="name()">参数</el-radio>
			 <el-radio v-model="form.radio" label="3" @change="name()">串号</el-radio>
			<!-- <el-radio v-model="radio" label="4">IP分组</el-radio>
			 <el-radio v-model="radio" label="5">Nube分组</el-radio> -->
			 <el-input
			   class="search"
			   size="small"
			   placeholder="搜索"
			   icon="el-icon-eleme"
			   v-model="form.name"
			  @keyup.enter.native="search" :on-icon-click="search"
			 ></el-input>
			 <el-button type="primary" size="small" @click="search()" style="margin-left: 10px">搜索</el-button>
			<!-- 分页 -->
			 <el-pagination
				class="paging"
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="form.pageNo"
				:page-size="form.pageSize"
				layout="total, prev, pager, next"
				:pager-count="7"
				:total="form.totalCount">
			  </el-pagination>
		</div>
		<div :style="{height:tableHeight - 10 +'px'}" style="margin-right: 10px;">
			<el-table
			:maxHeight="tableHeight - 10 + 'px'"
		    size="small"
			ref="multipleTable"
			:data="form.productList"
			tooltip-effect="dark"
			border
			empty-text="暂无数据,请查询..."
		>
<!--			<el-table-column prop="pname" label="产品名称"></el-table-column>	-->
			<el-table-column prop="tname" label="终端类型"></el-table-column>
			<el-table-column prop="gname" label="组" v-if="form.radio >= 1"></el-table-column>
			<el-table-column prop="npsKey" label="Key" v-if="form.radio == 1"></el-table-column>
			<el-table-column prop="paramName" label="参数" v-if="form.radio == 2"></el-table-column>
			<el-table-column prop="sn" label="串号" v-if="form.radio >= 3"></el-table-column>
			<!-- <el-table-column prop="paramDesc" label="IP分组"  width="120" align="center"></el-table-column>
			<el-table-column prop="paramDesc" label="Nube分组"  width="120" align="center"></el-table-column>	 -->
		</el-table>
		</div>
	</div>
</template>

<script>
import api from '@/api/content/'
import { mapState } from 'vuex';
//import Logan from 'logan-web';
export default {
	computed: {
		...mapState('main', ['tableHeight'])
	},
	data() {
		return {

			form: {
				productList:[],
				pageSize:15,
				pageNo: 1,//当前页码
				totalCount: 0,//总条数
				token:'',
				name:"",
				radio: '1',
			},
		};
	},
	created() {
	  // this.form.token = this.$cookies.get('USER_TOKEN_COOKIE');
    // let logContent = 'create content  ';
    // let logType = 2;

    // Logan.log(logContent, logType);
  },
	methods: {
		name(){
		this.form.productList = [];
		this.form.totalCount = 0;
		},
		search(){
			this.queryparam();
		},
		//改变每页显示数量时调用
		  handleSizeChange(val) {
		  this.$nextTick(() =>
		    this.queryparam(),
		  )
		},
		//点击下一页和点击页码时执行
		handleCurrentChange(val) {
		  this.queryparam();
		},
		// 查询
		queryparam(){
			this.form.productList = [];
			var val = '';
			if(this.form.radio == 1){
				val = this.form.name
			console.log(this.form.name)
			}else if(this.form.radio == 2){
				val = this.form.name
				console.log(this.form.name)
			}else if(this.form.radio == 3){
				val = this.form.name
				console.log(this.form.name)
			}
			var data = {
			  'pageNo':this.form.pageNo,
			  'pageSize':this.form.pageSize,
			  'name':val,
			  'token':this.form.token,
			  'type':this.form.radio
			};
		 api.queryparam(data)
			.then(res => {
				if(res.data.code == 0){
					this.form.productList = res.data.data.list;
					this.form.totalCount = res.data.data.totalSize
				}else{
					errorMsg({
						   message: res.data.msg
					})
				}
			})
		},
	}
};
</script>
<style scoped lang="less">
.content {
	margin-top: 10px;
	.crumbs {
		margin-top: 10px;
	}
	.header {
		position: relative;
        .paging{
			position: absolute;
			right: 0px;
			top: 0px;
		}
		.search {
			width: 200px;
		}
	}
	.a {
		cursor: pointer;
	}
}
</style>
